import { z } from 'zod';
/**
 * Accès à une demande de réservation sans session.
 *
 * Le nom de famille, et rien d'autre : contrairement au devis, aucun message ne
 * porte de lien vers cette page, il n'y a donc pas de secret à échanger. Le
 * client qui vient de réserver, lui, ne voit jamais ce formulaire — il repart
 * avec un jeton (voir ACCES-PERSO-JETON).
 */
export const grantReservationAccessSchema = z.object({
    lastName: z.string().trim().min(1).max(200),
});
